const DEFAULT_API_BASE_URL = "https://portal-api.uds-solutions.de";
const PORTAL_HOST_PREFIX = "portal.";
const PORTAL_API_HOST_PREFIX = "portal-api.";

const normalizeApiBaseUrl = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  return value.trim().replace(/\/+$/, "");
};

const resolveApiBaseUrl = () => {
  const configuredApiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);
  if (configuredApiBaseUrl !== null) {
    return configuredApiBaseUrl;
  }

  if (typeof window === "undefined") {
    return DEFAULT_API_BASE_URL;
  }

  const hostname = window.location.hostname.toLowerCase();
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:3008";
  }

  if (hostname.startsWith(PORTAL_HOST_PREFIX)) {
    const baseDomain = hostname.slice(PORTAL_HOST_PREFIX.length);
    return `${window.location.protocol}//${PORTAL_API_HOST_PREFIX}${baseDomain}`;
  }

  return DEFAULT_API_BASE_URL;
};

export const API_BASE_URL = resolveApiBaseUrl();

export const CONFIG = {
  API_BASE_URL,
};
